<template>
  <div id="AuthorsList" class="starter-template">
    <b-container fluid>

        <br>
        <b-row class="text-center">
            <b-col>
                <div class="shad" style="width: 15em; margin:auto">
                    <h3 class="txtShad">{{ this.$t('AUTHORS') }}</h3>
                </div>
            </b-col>
        </b-row>

        <b-row align-h="center" style="padding:2em">

            <div v-for="item in items"
                 :key="item.userName"
            >
                <b-col>

                    <b-card
                        title=''
                        :img-src=item.imgUrl
                        img-alt="Image"
                        img-top
                        tag="article"
                        style="max-width: 20rem;cursor:pointer"
                        body-class=itsBkg
                        class="mb-2 backWhite"
                        @click.prevent="showUserItems(item.userName)"
                    >
                        <b-row>
                            <b-col cols="9">
                            <a href="#" class="card-link"><h4 class="txtShad">{{ item.userName }}</h4></a>
                            </b-col>
                            <b-col cols="3">
                                <div @click.prevent.stop="showAvatar(item)"><b-avatar :src="item.avatarUrl" size="2.2em" ></b-avatar></div>
                            </b-col>
                        </b-row>
                    </b-card>

                </b-col>
            </div>
        </b-row>
        <b-row align-h="center">
            <b-pagination
                    v-model="curPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    v-if="listLength>perPage"
            ></b-pagination>

        </b-row>

    </b-container>

      <b-container fluid class="footer text-center"> &nbsp;&nbsp;&nbsp;
          <b-form-group class="m-2">
              <b-form-radio-group id="rg" v-model="footRadio" name="radio-sub-component">
                  <b-form-radio name="some-radios" value="trips" checked>
                      {{this.$t('T_S')}}
                  </b-form-radio>
                  <b-form-radio name="some-radios" value="places">
                      {{this.$t('PLACES')}}
                  </b-form-radio>
<!--
                  <b-form-radio name="some-radios" value="outings">
                      {{this.$t('OUTINGS')}}
                  </b-form-radio>

                  <b-form-radio name="some-radios" value="userMap">
                      {{this.$t('MAP')}}
                  </b-form-radio>
-->

              </b-form-radio-group>
          </b-form-group>

      </b-container>

      <b-modal
         id="mod-avat"
         :ok-only="true"
         :ok-title-html="$t('CLOSE')"
         :title="item.userName"
         header-class=itsBkg
         body-class=itsBkg
         footer-class=itsBkg
      >
          <b-avatar :src="item.avatarUrl" size="16em"></b-avatar>
      </b-modal>

  </div>

</template>

<script>
import { BRow, BCol, BContainer, BCard, BPagination, BFormGroup, BFormRadio, BFormRadioGroup,
    // BModal, BAvatar, BButton, BDropdown, BDropdownItem, } from 'bootstrap-vue';
    BModal, BAvatar } from 'bootstrap-vue';
export default {
  name: 'AuthorsList',
  components: {
    BRow, BCol, BContainer, BCard, BPagination, BFormGroup, BFormRadio, BFormRadioGroup, BModal, BAvatar
    //BButton, BDropdown, BDropdownItem
  },
  data: function() {
    return {
        items: [{}],
        intLoc: this.$i18n.locale,
        item: {},
        selected: null,
        footRadio: 'trips',
        perPage: 10,
        curPage: 1,
        curLang: '',
        listLength: 0,
        status: 'unchecked',
        title: '',
        metaDesc: ''
    }
  },
  metaInfo() {
     return {
        title: `${this.title}`,
        meta: [
            { vmid: 'description', name: 'description', content: this.metaDesc },
        ]
     }
  },
  beforeMount() {
    this.descMeta();
    this.blocked = this.$route.query.blocked;
    if(this.blocked==null) this.blocked = false;
    this.getAuthorsList();
  },
  methods: {
    async getAuthorsList() {
        try {
            const response = await this.$http.get('getAuthorsList', {
                params: {
                    pageNum: this.curPage,
                    blocked: this.blocked,
                    listLoc: this.intLoc
                }
            });
            this.items = response.data.itemList;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
            else {
                this.curPage = response.data.pageNum;
                this.listLength = response.data.listLen;
            }
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('AuthorsList: getAuthorsList() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    showUserItems(userName) {
        if(this.footRadio === 'userMap') {
            this.$router.push({
                path: '/Map/UserMap/_/'+this.$addEncHyp(userName),
            })
        }
        else {
            let comp = this.footRadio == 'places' ? '/UserPlacesList/' :
                this.footRadio == 'trips' ? '/UserTripsList/' : '/UserOutingsList/';
            this.$router.push({
                path: comp+this.$addEncHyp(userName)
            })
        }
    },
    chListLoc(newListLoc) {
        this.intLoc = newListLoc;
        this.getAuthorsList();
    },
    showAvatar(item) {
        if(item.avatarUrl==='') return;
        this.item = item;
        this.$bvModal.show('mod-avat')
    },
    descMeta() {
        if(this.$i18n.locale === 'ru') {
            this.title = 'Авторский каталог';
            this.metaDesc = 'Описания путешествий, мест, экскурсий, туров от наших авторов';
        }
        else {
            this.title = "Author's directory"
            this.metaDesc = 'Description of travels, places, excursions, tours by our authors';
        }
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.getAuthorsList();
    }
  },
  computed: {
    rows() {
        return this.listLength;
    }
  }
}

</script>

<style>
    #rg{
        color: white;
    }
    .tblName{
        color: white;
    }
    .bClass{
        background: green;
    }

</style>
